import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { REACT_APP_SKIP_LOGIN } from './config';

import AuthProvider from './auth/AuthProvider';
import AppRoute from './components/AppRoute';
import PropTypes from 'prop-types';
import { Spinner } from './constants';

const onBeforeUnloadCallback = () => localStorage.clear();

window.onbeforeunload = onBeforeUnloadCallback;

const App = ({ account, tokenResp, accessToken, onSignIn, onSignOut, redirecting, loading, error }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [eligibleVehResp, setEligibleVehResp] = useState(null);
  const spinnerRef = useRef(null);

  useEffect(() => {
    if (REACT_APP_SKIP_LOGIN) {
      setAuthenticated(true);
    } else {
      setAuthenticated(!!(localStorage.getItem('account') && localStorage.getItem('accessToken')));
    }
  }, [account, accessToken]);

  const handleSignOut = () => {
    onSignOut();
    setAuthenticated(false);
  };

  if (loading) {
    return (
      <div id='loading-spinner' className='loading-spinner'>
        <div className='spinner'></div>
      </div>
    );
  } else {
    return (
      <>
        <div id='loading-spinner' className={`loading-spinner ${Spinner.invisibleClass}`} ref={spinnerRef}>
          <div className='spinner'></div>
        </div>
        <AppRoute
          accessToken={accessToken}
          authenticated={authenticated}
          account={account}
          error={error}
          onSignIn={() => onSignIn()}
          onSignOut={handleSignOut}
          signUp={() => undefined}
          redirecting={redirecting}
          tokenResp={tokenResp}
          eligibleVehResp={eligibleVehResp}
          setEligibleVehResp={setEligibleVehResp}
          spinnerRef={spinnerRef}
        />
      </>
    );
  }
};

App.propTypes = {
  tokenResp: PropTypes.object,
  account: PropTypes.object,
  error: PropTypes.string,
  accessToken: PropTypes.object,
  onSignIn: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  redirecting: PropTypes.bool,
  loading: PropTypes.bool,
};

export { App };
export default AuthProvider(App);
